import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'perfil', loadChildren: () => import('./usuario/usuario.module').then(m => m.UsuarioModule) },
  { path: 'sucursales', loadChildren: () => import('./sucursales/sucursales.module').then(m => m.SucursalesModule) },
  { path: 'cotizar', loadChildren: () => import('./cotizador/cotizador.module').then(m => m.CotizadorModule) },
  { path: 'servicios', loadChildren: () => import('./tocars-servicios/tocars-servicios.module').then(m => m.TocarsServiciosModule) },
  { path: 'shared', loadChildren: () => import('./shared/shared.module').then(m => m.SharedModule) },
  { path: 'noticias', loadChildren: () => import('./noticias/noticias.module').then(m => m.NoticiasModule) },
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
